module.exports = __webpack_public_path__ + "img/sleeve upper arm width.f8ba8137.png";